/** Форматы dxNumberBox для бюджетных форм. */
export const MONEY_FORMAT = '#,##0.00';
export const VOLUME_FORMAT = '#,##0';
export const PRICE_KWH_FORMAT = '#,##0.00000';
